import React from "react";
import { ArticlesIndex } from "@ecologi/react-components/src/ArticlesIndex";
import { getWPData, mapWPDataToArticle, REBUILD_TIMEOUT } from "../../lib";
import { Wordpress } from "@ecologi/shared";
import logger from "../../lib/logger";

const ArticlesListMode = ArticlesIndex.modes;

export default function Articles(props) {
  return (
    <>
      <ArticlesIndex {...props} mode={ArticlesListMode.Blog} />
    </>
  );
}

export async function getStaticProps() {
  let data = [];
  let pageNumber = 1;

  // WP data can be huge, so chunk instead of fetching all at once
  while (true) {
    const res = await getWPData(
      `posts?per_page=${Wordpress.WORDPRESS_FETCH_PER_PAGE}&page=${pageNumber}&_fields=id,title,type,slug,date_gmt,acf.images.0.url,acf.images.0.caption,acf.images.0.sizes.medium_large,acf.images.0.sizes.large,_links.wp:term&_embed=wp:term`
    );

    if (!Array.isArray(res)) break;

    data = [...res, ...data];
    pageNumber++;

    logger.info(`Waiting on page ${pageNumber} for 'articles'...`);
    await new Promise((res) => setTimeout(res, 2e3)); // don't DOS the site
  }

  data.sort((a, b) => (a.date_gmt > b.date_gmt ? -1 : 1));

  return {
    revalidate: REBUILD_TIMEOUT,
    props: {
      data: data.map(mapWPDataToArticle),
      layoutProps: {
        isLightHeader: true,
        isWhiteBody: true,
      },
    },
  };
}
